import { useState } from 'react'
import {
    CaretLeftIcon,
    CaretRightIcon,
    ChartBarIcon,
    ChartLineUpIcon,
    TableIcon,
} from '@phosphor-icons/react'
import { ScoopSelector, ScoopText, ScoopSwitch } from '../../../../ui'
import { ChartSettings } from './ChartSettings'
import { ChartData } from './ChartData'
import { TimeRange } from './TimeRange'
import { useExplorer } from '../../../../../context/explorer'
import styles from './ConfigTab.module.scss'

const menuItems = [
    { id: 'chart', title: 'Chart', component: <ChartSettings /> },
    { id: 'chartData', title: 'Chart data', component: <ChartData /> },
    { id: 'timeRange', title: 'Time range', component: <TimeRange /> },
]

const viewTypeOptions = [
    {
        id: 'table',
        label: 'Table',
        value: 'table',
        leftSection: <TableIcon size={24} className={styles.viewTypeIcon} />,
        framedIcon: true,
    },
    {
        id: 'chart',
        label: 'Chart',
        value: 'chart',
        leftSection: <ChartBarIcon size={24} className={styles.viewTypeIcon} />,
        framedIcon: true,
    },
    {
        id: 'kpi',
        label: 'KPI',
        value: 'kpi',
        leftSection: <ChartLineUpIcon size={24} className={styles.viewTypeIcon} />,
        framedIcon: true,
    },
]

/**
 * ConfigTab component for chart configuration.
 *
 * Uses ExplorerContext via useExplorer().
 * Uses setView and toggleTimeSeries actions.
 */
export const ConfigTab = () => {
    // Get state and actions from context
    const { viewConfig, queryConfig, setView, toggleTimeSeries } = useExplorer()

    const [selectedConfigItem, setSelectedConfigItem] = useState(null)

    // Handle view type change
    const handleViewTypeChange = (e) => {
        setView(e.target.value)
    }

    // Handle time series toggle
    const handleTimeSeriesToggle = () => {
        toggleTimeSeries(!queryConfig.tableTimeSeries)
    }

    // Show time series toggle for table and KPI views
    const showTimeSeries = viewConfig.view === 'table' || viewConfig.view === 'kpi'

    if (selectedConfigItem) {
        return (
            <div className={styles.configDetailContainer}>
                <div
                    className={styles.configDetailHeader}
                    onClick={() => setSelectedConfigItem(null)}
                >
                    <CaretLeftIcon size={18} />
                    <ScoopText className={styles.configDetailTitle}>
                        {selectedConfigItem.title}
                    </ScoopText>
                </div>
                {selectedConfigItem.component}
            </div>
        )
    }

    return (
        <div className={styles.configTabContainer}>
            <ScoopSelector
                value={viewConfig.view}
                onChange={handleViewTypeChange}
                options={viewTypeOptions}
                className={styles.viewTypeSelector}
                size="lg"
            />

            {/* Time Series Toggle - for Table and KPI views */}
            {showTimeSeries && (
                <div className={styles.timeSeriesRow}>
                    <ScoopText className={styles.timeSeriesLabel}>Time series</ScoopText>
                    <ScoopSwitch
                        name="time-series-switch"
                        checked={queryConfig.tableTimeSeries}
                        onChange={handleTimeSeriesToggle}
                        disabled={queryConfig.disableTimeSeries}
                    />
                </div>
            )}

            <div className={styles.configMenuContainer}>
                {menuItems.map((item) => (
                    <div
                        key={item.id}
                        onClick={() => setSelectedConfigItem(item)}
                        className={styles.configMenuItem}
                    >
                        <ScoopText className={styles.configMenuItemText}>{item.title}</ScoopText>
                        <CaretRightIcon size={16} className={styles.configMenuItemIcon} />
                    </div>
                ))}
            </div>
        </div>
    )
}
